// src/shared/components/ErrorState/index.js
import React from 'react';
import { Container, Alert, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const ErrorState = ({ message, onRetry, onBack }) => (
    <Container className="text-center mt-5">
        <Alert variant="danger">
            <Alert.Heading>Error Loading Data</Alert.Heading>
            <p>{message}</p>
        </Alert>
        <div className="mt-3">
            <Button variant="primary" onClick={onRetry} className="me-2">
                Try Again
            </Button>
            {onBack && (
                <Button variant="secondary" onClick={onBack}>
                    Go Back
                </Button>
            )}
        </div>
    </Container>
);

ErrorState.propTypes = {
    message: PropTypes.string.isRequired,
    onRetry: PropTypes.func.isRequired,
    onBack: PropTypes.func
};

export default ErrorState;
